import React , { useEffect, useState }  from 'react'
import PropTypes from 'prop-types'
import CustomForm from '../../../../components/form/form'
import { Main } from '../../../../constant'
import { CustomBtn } from '../../../../components/button/button'
import { Box, Card, Grid, Typography } from '@mui/material'
import CustomTable from '../../../../components/table/SampleTableIncome'
import PageContainer from '../../../../components/Container/pageContainer'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { FullDate } from '../../../../components/Date/FullDate'
import { PostRequest } from '../../../../redux/actions/PostRequest'
import { useTheme } from '@emotion/react'
import SalesOverview from '../../Dashboard/components/SalesOverview'
import MonthlyEarnings from '../../Dashboard/components/MonthlyEarnings'
import ProductPerformance from '../../Dashboard/components/ProductPerformance'
import YearlyBreakup from '../../Dashboard/components/YearlyBreakup'
import { Height } from '@mui/icons-material'
import { ShowLoader } from '../../../../redux/actions/loader'
import './income.css'
import TransportPieChart from '../../Dashboard/components/transPortPie'

const Income = (props) => {
    const [data , setData ] = useState(Main().Income)
    const [getfilterdata , setGetfilterdata ] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const dispatch = useDispatch();
    const url = useSelector((state) => state.Api);
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
    const [initialInputValues , setInitialInputValues] = useState(Object.fromEntries(
        getfilterdata
            .map((item) => [item.name, ''])
    ));
    const theme = useTheme();
    const style = theme.palette;
    const [ serverData , setServerData ] = useState({
        data:''
    })
    const [inputValues, setInputValues] = useState({...initialInputValues });
    const [stduentaTeachers, setStduentaTeachers] = useState();
    const [fetched, setFetched] = useState(false);
    const [availAndRemovedStudents, setAvailAndRemovedStudents] = useState();
    
       
    const filterDataByDate = (leftStd) => {
        const fromDate = "2025-04-28";  // Provide your from date here
        const toDate = "2025-04-30";   // Provide your to date here
    
        // Convert the provided date strings to Date objects for comparison
        const from = new Date(fromDate);
        const to = new Date(toDate);
        const left = leftStd.filter((item) => {
            if (!item.ExitDate || item.ExitDate === 'undefined') {
                return false;
            }        
            const ExitDate = new Date(item.ExitDate);
            return ExitDate >= from && ExitDate <= to;
        }).length;  // Return only the length of the filtered data
        const enrolled = leftStd.filter((item) => {
            const admissionDate = new Date(item.AdmissionDate);
            return admissionDate >= from && admissionDate <= to;
        }).length;  // Return only the length of the filtered data
        return {leftStd: left.length, enrolledStd: enrolled}
    };
    
               
          const fetchData = async (param1 , param2) => {
            const FromDate = new Date(param1);
            const newdate = `${FromDate.getFullYear()}-${FromDate.getMonth() + 1}-${FromDate.getDate()}`;
            const payload = { 
                ...inputValues,
                ...(param1 ? { [param2]: newdate } : {})
            };
             
              try {
                  const response = await axios.post(url.income, payload, {
                      headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${userToken}`,
                      },
                  });
      
                  if (response.status === 200) { 
                    if(response.data.result != []){ 
                        setServerData((prevValues) => ({
                            ...prevValues,
                            data: response.data.result,
                        }));
                        // fetchOthers(payload)
                    }
                  }
              } catch (error) { 
              }
          };
      
    const fetchOthers = (payload) =>{
        // console.log(payload)
        // return false;
        try {
            dispatch(ShowLoader('1'))
            axios.post(`${url.profitLost}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(ShowLoader('0'))
                    // setStduentaTeachers(res.data);
                }
            })
            .catch((err) => {
                //console.error(err); // Log the error response for debugging
            });
        } catch (err) {
            //console.error(err);
        }
    }          

    const ChangeDate = (e , name) =>{
        //console.log(e , name)
        const converterToDate = new Date(e)
        setInputValues((prevValues) => ({
            ...prevValues,
            [name]:  `${converterToDate.getFullYear()}-${converterToDate.getMonth() + 1}-${converterToDate.getDate()}`
    }));
    fetchData(e,name)
    }

    const fetchLateFees = async() =>{
        // dispatch(ShowLoader('1'))
        try {
            const response = await axios.get(url.profitLost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });

            if (response.status === 200) {
              const getSortData =response.data.result.sort((a, b) => a.Amount - b.Amount)
              const totalEnrolledStdFeeDefaulters = getSortData.reduce((total, item) => {
                if (item.inOut === 1) {
                    return total + item.Amount;  // Add Amount if paid (inOut = 1)
                }
                return total;
            }, 0);
            
            const totalRemovedStdFeeDefaulters = getSortData.reduce((total, item) => {
                if (item.inOut === 0) {
                    return total + item.Amount;  // Add Amount if unpaid (inOut = 0)
                }
                return total;
            }, 0);
            //   setData(getSortData);
            const defaultersEnrolledInSchool = getSortData.filter(item => item.inOut === 1);  // Filter for paid (inOut = 1)
            const defaultersLeftSchool = getSortData.filter(item => item.inOut === 0);  // Filter for unpaid (inOut = 0)

            // console.log(totalEnrolledStdFeeDefaulters, totalRemovedStdFeeDefaulters)
            // console.log(defaultersEnrolledInSchool.length, defaultersLeftSchool.length)
            // console.log('------>'+filterDataByDate(getSortData).leftStd)
            // filterDataByDate()
            const stdDetails= {totalEnrolledStdFeeDefaulters, totalRemovedStdFeeDefaulters, defaultersEnrolledInSchool:defaultersEnrolledInSchool.length, defaultersLeftSchool:defaultersLeftSchool.length, totalStudents: getSortData }
            setAvailAndRemovedStudents(stdDetails)
            
            dispatch(ShowLoader('0'))
            }
        } catch (error) {
            dispatch(ShowLoader('0'))
            //console.error(error);
        }
    }   
    const fetchStudents = () => {
          try {
            //   dispatch(ShowLoader('1'))
              axios.get(`${url.studentList}`, {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${userToken}`,
                  },
              })
              .then((res) => {
                  if (res.status === 200) {
                    //   dispatch(ShowLoader('0'))
                      setStduentaTeachers(res.data);
                      setFetched(true)
                    //   fetchLateFees()
                  }
              })
              .catch((err) => { 
              });
          } catch (err) { 
          }
    }
      
 useEffect(()=>{
    if(!fetched)
        fetchStudents()
 },[])
    
  return (
      <PageContainer title={data.title} description={data.description}>


        <Box >
                    <Grid container>
                        <Grid item lg={6} xs={12} xl={6} mt={1}>
                            <Box className='students'>
                                <h1 className='numstd'>6832</h1>
                                <h1 className='number'>{stduentaTeachers?.studentsCount?.approvedStudents}</h1>
                                <h1 className='activestd'> ښاګردانو تعداد</h1>
                                <h1 className='nonActive'><b>{stduentaTeachers?.studentsCount?.pendingStudents}  </b>  غیرفعال </h1>
                            </Box>
                        </Grid>
                        <Grid item lg={6} xs={12} xl={6} mt={1}>
                            <Box className='students teacher'>
                                <h1 className='numstd'>Afgh</h1>
                                <h1 className='number'>{stduentaTeachers?.teacherCount?.approvedTeachers}</h1>
                                <h1 className='activestd'>کارمندانو تعداد</h1>
                                {/* <h1 className='nonActive'><b>{stduentaTeachers?.teacherCount?.pendingTeachers}  </b>  غیرفعال </h1> */}
                            </Box>
                        </Grid>
                        <Grid item lg={6} xs={12} xl={6} mt={1}>
                            <Box className='students defaulters'>
                                <h1 className='numstd'>6832</h1>
                                <h1 className='number'>{availAndRemovedStudents ? availAndRemovedStudents?.totalEnrolledStdFeeDefaulters :
                                    <CustomBtn style={{width: '40px'}} type="button" click={()=>fetchLateFees()} data="Load..."/>
                                }</h1>
                                <h1 className='activestd'> فعال ښاګردانو بقایاجات </h1>
                                <h1 className='nonActive'><b>{availAndRemovedStudents?.defaultersEnrolledInSchool}  </b>  ټوټل ښاګردان چی بقایات لری </h1>
                                {/* <h1 className='nonActive'><b>{availAndRemovedStudents?.totalEnrolledStdFeeDefaulters}  </b>  غیرفعال </h1> */}
                            </Box>
                        </Grid>
                        <Grid item lg={6} xs={12} xl={6} mt={1}>
                            <Box className='students teacher removedDefaulters'>
                                <h1 className='numstd'>خ ا ن</h1>
                                <h1 className='number'>{availAndRemovedStudents ? availAndRemovedStudents?.totalRemovedStdFeeDefaulters :
                                    <CustomBtn style={{width: '40px'}} type="button" click={()=>fetchLateFees()} data="Load..."/>
                                    }</h1>
                                <h1 className='activestd'>پر خارج سوی ښاګردانو بقایه</h1>
                                <h1 className='nonActive'><b>{availAndRemovedStudents?.defaultersLeftSchool}  </b>  خارج سوی ښاګردان </h1>
                            </Box>
                        </Grid>         
                    </Grid>
                    <Grid container>
                        <Grid item lg={3} xs={12} xl={3} mt={1}></Grid>
                        <Grid item lg={6} xs={6} xl={6} mt={1}>
                        <CustomForm data={data.inputs}  ChangeDate={ChangeDate}  />            
                        </Grid>
                        <Grid item lg={3} xs={12} xl={3} mt={1}></Grid>
                    </Grid>
                    {
                        serverData && serverData.data && serverData.data.length != 0 && (
                            <>
                                <YearlyBreakup totalInc={serverData.data?.ThirdRow?.Income} percentage={serverData.data.SecondRow[0].percentage} getdate={inputValues} data={serverData.data.SecondRow[0]} total={serverData.data.FirstRow[4].Payment} gTotal={serverData.data} />
                                {/* <CustomForm data={serverData.veiwDonation} handleInputChange={handleInputChange} /> */}
                                {/* <CustomTable data={serverData.veiwDonation} /> */}
                                <Grid container>
                                <Grid item lg={6} mt={2}>
                                    <Typography variant='h4' mb={2}>
                                        Income  عاید
                                    </Typography>
                                    <CustomTable data={serverData.data.FirstRow} />
                                </Grid>
                                <Grid item lg={1} mt={2}></Grid>

                                <Grid item lg={5} mt={10}>
                                    <Grid container>
                                    <Grid item lg={12} mt={0}>
                                    <Box>
                                    <TransportPieChart gTotal={{profit: serverData?.data?.FirstRow[0]?.Others?.Transport?.payment, loss:serverData?.data?.FirstRow[1]?.Others?.Transport?.payment, name: 'Transport', pName:'"ټرانسپورټ"', color1:'#5fa4ff', color2:'#f44336' }}/>
                                    {/* Content here */}
                                    </Box>
                                </Grid>
                                <Grid item lg={12} mt={5}>
                                    <Box>
                                    {/* <TransportPieChart gTotal={{profit: serverData?.data?.FirstRow[0]?.Others?.Hostel?.payment, loss:serverData?.data?.FirstRow[1]?.Others?.Hostel?.payment, name: 'Hostel', pName:'"لیلیه"', color1:'#f7f302', color2:'#ff3300' }}/> */}
                                    {/* <TransportPieChart gTotal={serverData?.data?.FirstRow}/> */}
                                    {/* Content here */}
                                    </Box>
                                </Grid>
                                    </Grid>
                                </Grid>

                                </Grid>
                                {/* <Box mt={4}>
                                    <Typography variant='h4'  mb={2}>
                                        Expense  لګښت 
                                    </Typography>
                                    <CustomTable data={[serverData.data.SecondRow]} />
                                </Box>
                                <Box>
                                    <Typography variant='h4'  mt={2}>
                                        <Grid>
                                        <Typography variant='span' mr={1} sx={{color: style.error.main}}>
                                            Total Income    عواید
                                        </Typography>
                                        </Grid>
                                         
                                         <Grid>
                                            <Typography variant='span'  sx={{color: style.primary.main}}>
                                                {
                                                    serverData.data.ThirdRow.Income
                                                }
                                            </Typography>
                                         </Grid>
                                        
                                    </Typography>
                                </Box> */}
                                {/* <YearlyBreakup  /> */}
                            </>
                        )
                    }


        </Box>
            
         
    </PageContainer>
  )
}

Income.propTypes = {}

export default Income
